import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {find, get} from 'lodash';

import GrowthTableRowImpactCellPopup from './GrowthTableRowImpactCellPopup';

export default function({row_data, impact_key, level_data, level_key, growthMin}) {
    // console.log('row_data', row_data);
    // console.log('level_data', level_data);

    const [showPopup, setShowPopup] = useState(false);

    const hasInsight = !!find(row_data, (old_impact_data, old_impact_key) => {
        if (!old_impact_data || old_impact_key >= impact_key) {
            return false;
        }
        const old_percentage = get(old_impact_data, [level_key, 'percentage']);
        const this_percentage = level_data.percentage;
        // For not_met and nearly_met, less % means growth insight
        if (level_key <= 1) {
            return old_percentage - this_percentage >= growthMin;
        } else {
            return this_percentage - old_percentage >= growthMin;
        }
    });

    const onClick = () => {
        if (!hasInsight) {
            return false;
        }
        setShowPopup(!showPopup);
    }

    const renderPopup = () => {
        if (!hasInsight || !showPopup) {
            return null;
        }
        return (
            <GrowthTableRowImpactCellPopup
                row_data={row_data}
                impact_key={impact_key}
                level_data={level_data}
                level_key={level_key}
                growthMin={growthMin}
                hasInsight={hasInsight}
            />
        );
    }

    const class_names = classNames('one-level', {
        'has-insight': hasInsight
    });

    return (
        <div className={class_names} onClick={onClick}>
            <div>
                {level_data.percentage}{`%`}
            </div>
            {renderPopup()}
        </div>
    );
}